import React from "react";

const QuoteService = () => {
  return (
    <section className="bg-black py-16 px-6  mx-auto">
      <div className=" mx-auto border border-white/70 px-6 md:px-16 py-14 md:py-20 text-center">
        {/* Main Quote */}
        <div className="max-w-5xl mx-auto">
          <h2
            className="  text-white font-semibold leading-tight
                       text-2xl sm:text-3xl md:text-4xl lg:text-3xl font-[Crimson] "
          >
            Grow your <span className="font-bold uppercase">businesses</span>{" "}
            with the right service
          </h2>

          {/* <div className="mt-12 flex justify-center">
            <img
              src="/images/signature.png"
              alt="Signature"
              className="w-40 md:w-56 object-contain"
            />
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default QuoteService;
